<template>
    <v-dialog v-model="terminalDialog" scrollable persistent max-width="500">
        <v-card>
            <v-card-title>
                <span class="headline"> {{terminalDialogTitle}} Terminale</span>
            </v-card-title>
            <v-card-text>
                <v-form>
                    <v-container grid-list>
                        <v-layout wrap>
                            <v-flex xs4>
                                <v-text-field
                                    v-if="terminalDialog" autofocus
                                    label="Serial Number" 
                                    v-model="newTerminal.sn" 
                                    v-validate="'required|unique'"
                                    data-vv-name="sn"
                                    data-vv-scope="terminalForm"
                                    :error-messages="errors.first('terminalForm.sn')"
                                    required
                                ></v-text-field>
                            </v-flex> 
                            <v-flex xs8>
                                <v-text-field
                                    label="Descrizione"
                                    v-model="newTerminal.description"
                                ></v-text-field>
                                
                            </v-flex>
                            <v-flex xs12>
                                <v-select
                                    :items="terminalTypes"
                                    v-model="newTerminal.type"
                                    label="Tipo di dispositivo"
                                ></v-select>
                            </v-flex>

                        </v-layout>
                    </v-container>
                </v-form>
                <v-btn color="info" @click="openPrinterMapDialog()">Stampanti</v-btn>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn color="error darken-1" flat @click="closeTerminalDialog">Annulla</v-btn>
                    <v-btn color="success darken-1" flat @click="saveTerminal">Salva</v-btn>
            </v-card-actions>
        </v-card>

        <printerMapDialog
            :printersMap="newMapping"
            :printers="this.$store.getters.stampanti"
            :printerMapDialog="printerMapDialog"
            @closeDialog="closePrinterMapDialog"
        /> 

    </v-dialog> 
</template>

<script>
/**
 * Form Modale dei Terminals
 * @module components/common/Changed
 */
export default {
    name: 'terminalDialog',
    props:[
        'terminalDialog', 'newTerminal', 'terminalDialogTitle', 'terminals', 'isEdit'
    ],
    data(){
        return {     
            terminalTypes: [
                {
                    text: "PC",
                    value: "PC"
                },
                {
                    text: "Android",
                    value: "Android"
                }
            ],
            printerMapDialog: false,
            newMapping: [],
        }
    },
    created() {
        this.uniqueValidation(this.newTerminal.sn);        
    },
    methods: {
        uniqueValidation() {
            //CUSTOM VALIDATION RULE FOR SERIAL NUMBER FIELD ON TERMINAL FORM
            this.$validator.extend('unique', {
                getMessage(field, args) {
                    return 'Questo Serial Number è già stato utilizzato.'
                },
                validate: (value, args) => { 
                    let isOk = true;
                    
                    this.terminals.forEach(element => {
                        if ((element.sn.toLowerCase().trim()  === value.toLowerCase().trim()) && (value.toLowerCase().trim() != this.isEdit)) {
                            isOk = false;
                        } 
                    });
                    return isOk;
                }
            });
        },
        closeTerminalDialog() {
            this.$validator.reset();
            this.newTerminal.sn = "";
            this.newTerminal.type = "PC";
            this.newTerminal.description = "";
            this.newTerminal.mappings = [];
            this.$emit('closeTerminalDialog', false);
        },  
        saveTerminal() {
            var vm = this;
            var done = false;
            var message;            

            this.$validator.validate("terminalForm.*").then((result) => {
                if (result) {
                    //try find the object in the array served by the DB, if it finds it, the object is updated.
                    this.terminals.forEach((terminal, index, terminals) => {
                        if (terminal.sn == vm.isEdit && !done) {
                            vm.terminals.splice(index, 1, utils.clone(vm.newTerminal));
                            done = true;
                            message = 'Terminale modificato. Ricorda di salvare le impostazioni.'
                        }
                    });
                    //if dont find the object in the array it pushes the new one
                    if (!done) {
                        message = 'Terminale inserito. Ricorda di salvare le impostazioni.'
                        vm.terminals.push(utils.clone(vm.newTerminal));
                    }
                    this.closeTerminalDialog();
                    this.$store.dispatch('PUSH_MESSAGE', message);
                }
            });
        },
        openPrinterMapDialog() { 
            this.newMapping = utils.clone(this.newTerminal.mappings);
            this.printerMapDialog = true
        },
        closePrinterMapDialog(data) {
            if (data) {
                this.newTerminal.mappings  = [...data]
            }            
            this.printerMapDialog = false;
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/common/TerminalDialog.vue